import { render, staticRenderFns } from "./NsExpressiveLink.vue?vue&type=template&id=2dccdd90&scoped=true&"
import script from "./NsExpressiveLink.vue?vue&type=script&lang=js&"
export * from "./NsExpressiveLink.vue?vue&type=script&lang=js&"
import style0 from "./NsExpressiveLink.vue?vue&type=style&index=0&id=2dccdd90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dccdd90",
  null
  
)

export default component.exports